import { gql } from '@apollo/client'
import { client } from '../client'

const CREATE_DRIVER_TRAINING_MUTATION = gql`
  mutation CreateDriverTraining(
    $driverIdNo: String!,
    $driverIdType: String!,
    $driverName: String!,
    $phoneNumber: String!
  ) {
    createDriverTraining(
      driverIdNo: $driverIdNo,
      driverIdType: $driverIdType,
      driverName: $driverName,
      phoneNumber: $phoneNumber
    )
  }
`

interface CreateDriverTrainingData {
  createDriverTraining: boolean
}

interface CreateDriverTrainingVars {
  driverIdNo: string
  driverIdType: string
  driverName: string
  phoneNumber: string
}

export const createDriverTraining = (args: CreateDriverTrainingVars) => {
  return client.mutate<CreateDriverTrainingData, CreateDriverTrainingVars>({
    mutation: CREATE_DRIVER_TRAINING_MUTATION,
    variables: args,
  })
}
